import styled from "styled-components";

export const Container = styled.div`
  margin: 0 auto;
  max-width: 900px;
  @media (max-width: 430px) {
    width: 393px;
    margin: 0;
  }
`;

export const ErrorMesg = styled.div`
  font-size: 60px;
`;

export const BlogContainer = styled.div`
  width: 1470px;
  margin: 0 auto;
  margin-bottom: 40px;
  font-size: 75px;
  @media (max-width: 430px) {
    margin: 0;
  }
`;
type ImageProps = {
  $img: string;
};

export const InnerContainer = styled.div<ImageProps>`
  margin: 0 auto;
  width: 70%;
  height: 550px;
  width: 1300px;
  border-radius: 30px;
  background-image: url(${(props) =>
    props.$img === props.$img ? props.$img : props.$img});
  background-repeat: no-repeat;
`;
export const H1 = styled.h1`
  text-align: center;
  font-family: Cormorant Infant;
  font-size: 75px;
  font-weight: 500;
  margin-bottom: 40px;
  @media (max-width: 430px) {
    width: 393px;
    font-size: 55px;
  }
`;
export const Ul = styled.ul`
  max-width: 1400px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 20px;
  margin-left: 100px;

  @media (max-width: 430px) {
    flex-direction: column;
    flex-wrap: nowrap;
    width: 393px;
    margin: 0;
    margin-left: 10px;
  }
`;
export const Ul2 = styled.ul`
  max-width: 1400px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin: 0 auto;

  @media (max-width: 430px) {
    flex-direction: column;
    flex-wrap: nowrap;
    width: 393px;
    margin: 0;
    margin-left: 10px;
  }
`;
export const UlC = styled.ul`
  display: flex;
  gap: 12px;
  justify-content: center;
  margin-bottom: 40px;
`;

export const Tags2 = styled.div`
  margin: 0 auto;
  display: flex;
  gap: 12px;
  margin-bottom: 44px;
  margin-top: 20px;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;

  @media (max-width: 430px) {
    flex-wrap: nowrap;
    justify-content: start;
    margin-left: 20px;
    overflow-x: auto;
    overflow-y: hidden;
    margin-right: 10px;
    height: 30px;
  }
`;

export const Tag2 = styled.div`
  font-family: Avenir Next;
  font-size: 1rem;
  font-weight: 500;
  border: 1px solid black;
  border-radius: 20px;
  padding: 5px 10px;
  cursor: pointer;
  height: 30px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  /* min-width: 100px; */
  background-color: ${(props) => (props.isActive ? "#bfdcf5" : "white")};
  border-color: ${(props) => (props.isActive ? "#bfdcf5" : "black")};

  &:active {
    border: 1px solid #bfdcf5;
    background-color: #bfdcf5;
  }
`;

export const Tag1 = styled(Tag2)`
  background-color: ${(props) => (props.isActive ? "#bfdcf5" : "white")};
  border-color: ${(props) => (props.isActive ? "#bfdcf5" : "black")};
`;
